'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver from "./com.raquo.airstream.common.-Internal-Try-Observer.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1() {
}
export { $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1 as $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1 };
$p = $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_split_SplitSignal$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplitSignal$$anon$1() {
}
export { $h_Lcom_raquo_airstream_split_SplitSignal$$anon$1 as $h_Lcom_raquo_airstream_split_SplitSignal$$anon$1 };
$h_Lcom_raquo_airstream_split_SplitSignal$$anon$1.prototype = $p;
$p.fW = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.fV = (function(nextError, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.fX = (function(nextValue, transaction) {
});
var $d_Lcom_raquo_airstream_split_SplitSignal$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_split_SplitSignal$$anon$1, "com.raquo.airstream.split.SplitSignal$$anon$1", ({
  hb: 1,
  aj: 1,
  ay: 1
}));
export { $d_Lcom_raquo_airstream_split_SplitSignal$$anon$1 as $d_Lcom_raquo_airstream_split_SplitSignal$$anon$1 };
